<template>
  <div class="row">
    <player-display
      :media_type="media_type"
      :audio_file_url="audio_file_url"
      :video_id="video_id"
      :settings="settings"
      :slides="course_presentation_lesson_slides"
      :init_player="true"></player-display>
  </div>
</template>

<script>
  import PlayerDisplay from '../../shared/components/embodia_player/display.vue'
  export default {
    components: {PlayerDisplay},
    props: {
      video_id: {
        type: String,
        required: false,
      },
      audio_file_url: {
        type: String,
        required: false
      },
      settings: {
        type: Object,
        required: true
      },
      course_presentation_lesson_slides: {
        type: Array,
        required: true
      },
    },
    computed: {
      media_type: function(){
        if (this.video_id) {
          return 'video'
        } else if (this.audio_file_url) {
          return 'audio'
        }
      }
    }
  }
</script>